// import React, { useState, useEffect } from "react";
// import { useLocation, Link } from "react-router-dom";
// import { AddShoppingCart, Adjust, AcUnit } from "@material-ui/icons";

// // import usePermissions from '../../utils/permissions';
// const NavBar = () => {
//   const location = useLocation();
//   const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile")));
//   const [isInvoiceSubmenuOpen, setIsInvoiceSubmenuOpen] = useState(false);
// // Use permissions hook to get isAdmin status
// // const { isAdmin } = usePermissions();

//   useEffect(() => {
//     setUser(JSON.parse(localStorage.getItem("profile")));
//   }, [location]);

//   if (!user) return null;

//   return (
//     <div>
//       {location.pathname !== "/PosMainScreen" && (
//         <nav className="navbar" style={{ position: "fixed" }}>
//           <ul className="navbar-nav">
//             <li className="logo">
//               <Link to="/PosMainScreen" className="nav-link">
//                 <span className="link-text logo-text">
//                   <img
//                     style={{
//                       width: "100px",
//                       padding: "10px",
//                       marginTop: "10px",
//                     }}
//                     src="https://mindtree.co.th/wp-content/uploads/mindtreetechnologies.svg"
//                     alt="arc-invoice"
//                     onClick={() => (window.location.href = "/PosMainScreen")}
//                   />
//                 </span>
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="24"
//                   height="24"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   className="feather feather-arrow-right"
//                 >
//                   <line x1="5" y1="12" x2="19" y2="12"></line>
//                   <polyline points="12 5 19 12 12 19"></polyline>
//                 </svg>
//               </Link>
//             </li>
//             <li className="nav-item">
//               <Link to="/PosMainScreen" className="nav-link">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="24"
//                   height="24"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   className="feather feather-pie-chart"
//                 >
//                   <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
//                   <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
//                 </svg>
//                 <span className="link-text">PoS</span>
//               </Link>
//             </li>

//             <li className="nav-item">
//               <div
//                 className="nav-link"
//                 onClick={() => setIsInvoiceSubmenuOpen(!isInvoiceSubmenuOpen)}
//                 style={{
//                   cursor: "pointer",
//                   display: "flex",
//                   alignItems: "center",
//                 }}
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="24"
//                   height="24"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   className="feather feather-layers"
//                 >
//                   <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
//                   <polyline points="2 17 12 22 22 17"></polyline>
//                   <polyline points="2 12 12 17 22 12"></polyline>
//                 </svg>
//                 <span className="link-text">Invoices</span>
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="24"
//                   height="24"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   style={{ marginLeft: "5px" }}
//                 >
//                   <polyline points="6 9 12 15 18 9"></polyline>
//                 </svg>
//               </div>
//               {isInvoiceSubmenuOpen && (
//                 <ul
//                   className="nav-item"
//                   onClick={() => setIsInvoiceSubmenuOpen(!isInvoiceSubmenuOpen)}
//                 >
//                   <li className="nav-item">
//                     <Link to="/invoices" className="nav-link">
//                       <span className="link-text">All Invoices</span>
//                     </Link>
//                   </li>
//                   <li className="nav-item">
//                     <Link to="/invoices/credit" className="nav-link">
//                       <span className="link-text">Credit Invoices</span>
//                     </Link>
//                   </li>
//                 </ul>
//               )}
//             </li>

//             {/* Rest of the existing code remains the same */}
//             <li className="nav-item">
//               <Link to="/customers" className="nav-link">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="24"
//                   height="24"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   className="feather feather-users"
//                 >
//                   <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
//                   <circle cx="9" cy="7" r="4"></circle>
//                   <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
//                   <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
//                 </svg>
//                 <span className="link-text">Customers</span>
//               </Link>
//             </li>
//               <li className="nav-item">
//                 <Link to="/adminDashboard" className="nav-link">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     width="24"
//                     height="24"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     className="feather feather-user-plus"
//                   >
//                     <path d="M16 21v-2a4 4 0 0 0-3-3.87"></path>
//                     <path d="M7 21v-2a4 4 0 0 1 4-4h5"></path>
//                     <circle cx="8.5" cy="7" r="4"></circle>
//                     <line x1="20" y1="8" x2="20" y2="14"></line>
//                     <line x1="23" y1="11" x2="17" y2="11"></line>
//                   </svg>
//                   <span className="link-text">Add User</span>
//                 </Link>
//               </li>

//               <li className="nav-item">
//                 <Link to="/purchases" className="nav-link">
//                   <AddShoppingCart />
//                   <span className="link-text">Purchases</span>
//                 </Link>
//               </li>
//               <li className="nav-item">
//                 <Link to="/stockAdjustments" className="nav-link">
//                   <Adjust />
//                   <span className="link-text">Stock Adjustment</span>
//                 </Link>
//               </li>
//               <li className="nav-item">
//                 <Link to="/ItemsList" className="nav-link">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     viewBox="0 0 48 48"
//                     width="24px"
//                     height="24px"
//                     stroke="currentColor"
//                   >
//                     <path d="M 1 3 L 1 15 L 3 15 L 3 48 L 47 48 L 47 15 L 49 15 L 49 3 Z M 3 5 L 47 5 L 47 13 L 3 13 Z M 5 15 L 45 15 L 45 46 L 5 46 Z M 17.5 19 C 15.578125 19 14 20.578125 14 22.5 C 14 24.421875 15.578125 26 17.5 26 L 32.5 26 C 34.421875 26 36 24.421875 36 22.5 C 36 20.578125 34.421875 19 32.5 19 Z M 17.5 21 L 32.5 21 C 33.339844 21 34 21.660156 34 22.5 C 34 23.339844 33.339844 24 32.5 24 L 17.5 24 C 16.660156 24 16 23.339844 16 22.5 C 16 21.660156 16.660156 21 17.5 21 Z" />
//                   </svg>
//                   <span className="link-text">Items</span>
//                 </Link>
//               </li>

//             {/* {user?.result?.userType === "admin" && ( */}
//               <li className="nav-item">
//                 <Link to="/UnitsList" className="nav-link">
//                   <AcUnit />
//                   <span className="link-text">Units</span>
//                 </Link>
//               </li>
//             {/* )} */}
//             <li className="nav-item" id="themeButton">
//               <a href="/settings" className="nav-link">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="24"
//                   height="24"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   className="feather feather-settings"
//                 >
//                   <circle cx="12" cy="12" r="3"></circle>
//                   <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
//                 </svg>
//                 <span className="link-text">Settings</span>
//               </a>
//             </li>
//           </ul>
//         </nav>
//       )}
//     </div>
//   );
// };

// export default NavBar;

//========================================================

import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AddShoppingCart, Adjust, AcUnit } from "@material-ui/icons";
import usePermissions from "../../utils/permissions";
import elixirLogo from "./elixir2.jpg";
import { QrScanner, BogieMaster } from "../Dashboard/Icons";

const NavBar = ({ forceVisible = false }) => {
  const location = useLocation();
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile")));
  const [isInvoiceSubmenuOpen, setIsInvoiceSubmenuOpen] = useState(false);
  const [isItemsSubmenuOpen, setIsItemsSubmenuOpen] = useState(false);

  // Use permissions hook
  const { isAdmin, canReadPage } = usePermissions();

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("profile")));
  }, [location]);

  if (!user) return null;

  // Hide navbar on /PosMainScreen or /edit/invoice/* routes
  if (
    (!forceVisible && location.pathname === "/PosMainScreen") ||
    location.pathname.startsWith("/edit/invoice")
  )
    return null;

  const navigateWithRefresh = (path) => {
    window.location.href = `${path}?refresh=true`;
  };

  return (
    <div>
      <nav className="navbar" style={{ position: "fixed" }}>
        <ul className="navbar-nav">
          <li className="logo">
            <div className="nav-link" onClick={() => navigateWithRefresh("/PosMainScreen")}>
              <span className="link-text logo-text">
                <img
                  style={{
                    width: "116px",
                    padding: "10px",
                    marginTop: "10px",
                  }}
                  src={elixirLogo}
                  alt="elixir-logo"
                  onClick={() => navigateWithRefresh("/PosMainScreen")}
                />
              </span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-arrow-right"
              >
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </div>
          </li>
          {/* <li className="nav-item">
            <Link to="/PosMainScreen" className="nav-link">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-pie-chart"
              >
                <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
                <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
              </svg>
              <span className="link-text">PoS</span>
            </Link>
          </li> */}

          {(isAdmin() || canReadPage("Invoice")) && (
            <li className="nav-item">
              <div
                className="nav-link"
                onClick={() => setIsInvoiceSubmenuOpen(!isInvoiceSubmenuOpen)}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-layers"
                >
                  <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                  <polyline points="2 17 12 22 22 17"></polyline>
                  <polyline points="2 12 12 17 22 12"></polyline>
                </svg>
                <span className="link-text">Invoices</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ marginLeft: "5px" }}
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </div>
              {isInvoiceSubmenuOpen && (
                <ul
                  className="nav-item"
                  onClick={() => setIsInvoiceSubmenuOpen(!isInvoiceSubmenuOpen)}
                >
                  <li className="nav-item">
                    <div
                      to="/invoices"
                      className="nav-link"
                      onClick={() => navigateWithRefresh("/invoices")}
                      ss
                    >
                      <span className="link-text">All Invoices</span>
                    </div>
                  </li>
                  <li className="nav-item">
                    <div className="nav-link" onClick={() => navigateWithRefresh("/invoices/credit")}>
                      <span className="link-text">Credit Invoices</span>
                    </div>
                  </li>
                </ul>
              )}
            </li>
          )}
          {(isAdmin() || canReadPage("Customer")) && (
            <li className="nav-item">
              <div className="nav-link" onClick={() => navigateWithRefresh("/customers")}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-users"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
                <span className="link-text">Customers</span>
              </div>
            </li>
          )}


{/* {(isAdmin() || canReadPage("Customer")) && (
            <li className="nav-item">
              <Link to="/suppliers" className="nav-link">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-users"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
                <span className="link-text">Suppliers</span>
              </Link>
            </li>
          )}

<li className="nav-item">
              <Link to="/supplier-dues" className="nav-link">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-users"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
                <span className="link-text">Suppliers-Due</span>
              </Link>
            </li> */}

            {/* <li className="nav-item">
              <Link to="/cash-management" className="nav-link">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-users"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
                <span className="link-text">Cash-Management</span>
              </Link>
            </li> */}

          {isAdmin() && (
            <li className="nav-item">
              <div className="nav-link" onClick={() => navigateWithRefresh("/adminDashboard")}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-user-plus"
                >
                  <path d="M16 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M7 21v-2a4 4 0 0 1 4-4h5"></path>
                  <circle cx="8.5" cy="7" r="4"></circle>
                  <line x1="20" y1="8" x2="20" y2="14"></line>
                  <line x1="23" y1="11" x2="17" y2="11"></line>
                </svg>
                <span className="link-text">Add User</span>
              </div>
            </li>
          )}

          {/* {isAdmin() && (
            <li className="nav-item">
              <Link to="/dashboard" className="nav-link">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-user-plus"
                >
                  <path d="M16 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M7 21v-2a4 4 0 0 1 4-4h5"></path>
                  <circle cx="8.5" cy="7" r="4"></circle>
                  <line x1="20" y1="8" x2="20" y2="14"></line>
                  <line x1="23" y1="11" x2="17" y2="11"></line>
                </svg>
                <span className="link-text">Dashboard</span>
              </Link>
            </li>
          )} */}

          {/* {(isAdmin() || canReadPage("Purchase")) && (
            <li className="nav-item">
              <Link to="/purchases" className="nav-link">
                <AddShoppingCart />
                <span className="link-text">Purchases</span>
              </Link>
            </li>
          )}
          {(isAdmin() || canReadPage("stockAdjustment")) && (
            <li className="nav-item">
              <Link to="/stockAdjustments" className="nav-link">
                <Adjust />
                <span className="link-text">Stock Adjustment</span>
              </Link>
            </li>
          )} */}

          {(isAdmin() || canReadPage("Items")) && (
            <li className="nav-item">
              <div
                className="nav-link"
                onClick={() => setIsItemsSubmenuOpen(!isItemsSubmenuOpen)}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 48 48"
                  width="24px"
                  height="24px"
                  stroke="currentColor"
                >
                  <path d="M 1 3 L 1 15 L 3 15 L 3 48 L 47 48 L 47 15 L 49 15 L 49 3 Z M 3 5 L 47 5 L 47 13 L 3 13 Z M 5 15 L 45 15 L 45 46 L 5 46 Z M 17.5 19 C 15.578125 19 14 20.578125 14 22.5 C 14 24.421875 15.578125 26 17.5 26 L 32.5 26 C 34.421875 26 36 24.421875 36 22.5 C 36 20.578125 34.421875 19 32.5 19 Z M 17.5 21 L 32.5 21 C 33.339844 21 34 21.660156 34 22.5 C 34 23.339844 33.339844 24 32.5 24 L 17.5 24 C 16.660156 24 16 23.339844 16 22.5 C 16 21.660156 16.660156 21 17.5 21 Z" />
                </svg>
                <span className="link-text">Items</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ marginLeft: "5px" }}
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </div>
              {isItemsSubmenuOpen && (
                <ul
                  className="nav-item"
                  onClick={() => setIsItemsSubmenuOpen(!isItemsSubmenuOpen)}
                >
                  <li className="nav-item">
                    <div
                      className="nav-link"
                      onClick={() => navigateWithRefresh("/ItemsList")}
                    >
                      <span className="link-text">ItemsList</span>
                    </div>
                  </li>
                  <li className="nav-item">
                    <div
                      className="nav-link"
                      onClick={() => navigateWithRefresh("/bulk-upload")}
                    >
                      <span className="link-text">Bulk Add Items</span>
                    </div>
                  </li>
                </ul>
              )}
            </li>
          )}

          {(isAdmin() || canReadPage("Units")) && (
            <li className="nav-item">
              <div className="nav-link" onClick={() => navigateWithRefresh("/UnitsList")}>
                <AcUnit />
                <span className="link-text">Units</span>
              </div>
            </li>
          )}

          <li className="nav-item">
            <div className="nav-link" onClick={() => navigateWithRefresh("/qr-scan-report")}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-grid"
              >
                <rect x="3" y="3" width="7" height="7" />
                <rect x="14" y="3" width="7" height="7" />
                <rect x="3" y="14" width="7" height="7" />
                <path d="M14 14h7v7h-7z" />
              </svg>
              <span className="link-text">QR Scan Report</span>
            </div>
          </li>

          <li className="nav-item">
            <div className="nav-link" onClick={() => navigateWithRefresh("/qr-scanner")}>
              <QrScanner />
              <span className="link-text">QR Scanner</span>
            </div>
          </li>

          <li className="nav-item">
            <div className="nav-link" onClick={() => navigateWithRefresh("/bogie-master")}>
              <BogieMaster />
              <span className="link-text">Bogie Master</span>
            </div>
          </li>

          <li className="nav-item" id="themeButton">
            <div className="nav-link" onClick={() => navigateWithRefresh("/settings")}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-settings"
              >
                <circle cx="12" cy="12" r="3"></circle>
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
              </svg>
              <span className="link-text">Settings</span>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default NavBar;
